import * as React from 'react';

function EmergencyIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M4.364 21v-2.235h1.745l2.155-7.349c.145-.484.413-.87.804-1.16a2.13 2.13 0 011.296-.432h3.272c.473 0 .905.144 1.296.433.39.288.659.675.804 1.16l2.155 7.348h1.745V21H4.364zm6.545-13.412V2h2.182v5.588h-2.182zm6.491 2.766l-1.554-1.592 3.872-3.94 1.527 1.565-3.845 3.967zm1.146 5.058v-2.236H24v2.236h-5.454zM6.6 10.354L2.755 6.387l1.527-1.565 3.873 3.94L6.6 10.354zM0 15.412v-2.236h5.455v2.236H0z"
        fill="#E11D48"
      />
    </svg>
  );
}

const MemoEmergencyIcon = React.memo(EmergencyIcon);
export default MemoEmergencyIcon;
